import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBrochure } from "../brochureModel";

export const getAllBrochures = createAsyncThunk(
  "Brochure/FindAllBrochure",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/FindAllBrochure`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Brochures:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createBrochure = createAsyncThunk(
  "Brochure/InsertBrochure",
  async (BrochureData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/InsertBrochure`,
        BrochureData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating brochure:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBrochure = createAsyncThunk(
  "Brochure/UpdateBrochure",
  async (BrochureData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/UpdateBrochure`,
        BrochureData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating brochure:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBrochure = createAsyncThunk(
  "Brochure/DeleteBrochure",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/DeleteBrochure`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting brochure:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBrochureByID = createAsyncThunk(
  "Brochure/FindByIDBrochure",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/FindByIDBrochure`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SectorID: result.SectorID,
        Documents: result.Documents,
        IsActive: result?.isActive ? 1 : 2,
      } as IBrochure;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching brochure:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// export const getAllActiveBrochures = createAsyncThunk(
//   "Brochure/FindAllActiveBrochure",
//   async () => {
//     try {
//       const response = await axiosApiInstance.get(
//         `${API_URL}/Brochure/FindAllActiveBrochure`
//       );
//       return response.data?.Data;
//     } catch (error: any) {
//       // ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error Fetching Brochures:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

export const ActiveInactiveBrochure = createAsyncThunk(
  "Brochure/ActiveInActiveBrochure",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/ActiveInActiveBrochure`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive brochure:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const uploadBrochureAttachments = createAsyncThunk(
  "Brochure/BrochureAttachments",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/BrochureAttachments`,
        formData
      );
      SuccessToast(response.data?.Message || "File Upload Successfully!");
      return response.data;
    } catch (error: any) {
      console.error("Error Upload Brochure Attachments:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBrochureAttachment = createAsyncThunk(
  "Brochure/DeleteBrochureDocument",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Brochure/DeleteBrochureDocument`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting brochure attachment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
